import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import dirhamIcon from 'assets/images/dirham-symbol.png';
import { getDirhamSymbolSizePx } from 'utils/currency';

export default function DirhamSymbol({ size, variant, sx = {} }) {
  const theme = useTheme();
  const px = size ?? getDirhamSymbolSizePx(variant || 'body2', theme);

  return (
    <Box
      component="img"
      src={dirhamIcon}
      alt="AED"
      sx={{
        height: px,
        width: 'auto',
        maxWidth: px * 1.1,
        objectFit: 'contain',
        objectPosition: 'center',
        display: 'inline-block',
        verticalAlign: '-0.12em',
        flexShrink: 0,
        ...sx
      }}
    />
  );
}

DirhamSymbol.propTypes = {
  size: PropTypes.number,
  variant: PropTypes.string,
  sx: PropTypes.object
};
